import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';
import { useT } from '../../i18n';
import { getServerUrl, normalizeServerUrl, setServerUrl } from '../../native/platform';
import { useSession } from '../../store/session';
import controls from '../controls.module.css';
import styles from './Auth.module.css';
import { AuthLayout, Field } from './AuthLayout';

/** Android only: which server this phone talks to. Checked before it is kept. */
export function ServerUrl() {
  const t = useT();
  const navigate = useNavigate();
  const refreshMeta = useSession((s) => s.refreshMeta);
  const [value, setValue] = useState(getServerUrl() ?? '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    const url = normalizeServerUrl(value);
    if (!url) {
      setError(t.t('server.unreachable'));
      return;
    }
    setBusy(true);
    setError(null);
    try {
      const res = await fetch(`${url}/api/meta`);
      if (!res.ok) throw new Error(String(res.status));
      const meta = (await res.json()) as { appTitle?: string };
      if (typeof meta.appTitle !== 'string') throw new Error('not hmawiw');
      setServerUrl(url);
      await refreshMeta();
      navigate('/login', { replace: true });
    } catch {
      setError(t.t('server.unreachable'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title={t.t('server.hint')}>
      <form className={styles.form} onSubmit={(e) => void submit(e)}>
        <h2 className="display" style={{ margin: 0, fontSize: 20 }}>
          {t.t('server.title')}
        </h2>
        <Field label={t.t('server.label')}>
          <input className={controls.field} value={value} onChange={(e) => setValue(e.target.value)} placeholder="hmawiw.example.net" inputMode="url" autoCapitalize="none" autoCorrect="off" spellCheck={false} required />
        </Field>
        {error ? <p className={styles.error} role="alert">{error}</p> : null}
        <button type="submit" className={`${controls.btn} ${controls.primary}`} disabled={busy}>
          {busy ? t.t('auth.working') : t.t('server.check')}
        </button>
      </form>
    </AuthLayout>
  );
}
